import * as z from "zod";
import { gql } from "graphql-request";

import { SysSchema, SysFragment } from "../sys";
import { TargetingSchema, TargetingFragment } from "../targeting";
import {
  FullscreenEntryCarouselSchema,
  FullscreenEntryCarouselFragment,
} from "./fullscreenCarousel";
import { RelatedMediaSchema, RelatedMediaFragment } from "../relatedMedia";

export const FullscreenEntrySchema = z.object({
  __typename: z.literal("FullscreenEntry"),
  sys: SysSchema,
  sortDate: z.string().nullable(),
  targeting: TargetingSchema.nullish(),
  relatedMedia: RelatedMediaSchema.nullish(),
  localized: z
    .discriminatedUnion("__typename", [FullscreenEntryCarouselSchema])
    .nullish(),
});

export const FullscreenEntry = FullscreenEntrySchema;
export type FullscreenEntry = z.infer<typeof FullscreenEntrySchema>;

export const FullscreenEntryFragment = gql`
  fragment FullscreenEntryFragment on FullscreenEntry {
    __typename
    sys {
      ...SysFragment
    }

    targeting {
      ...TargetingFragment
    }

    relatedMedia {
      ...RelatedMediaFragment
    }

    sortDate
    localized {
      ... on FullscreenEntryCarousel {
        ...FullscreenEntryCarouselFragment
      }
    }
  }

  ${SysFragment}
  ${FullscreenEntryCarouselFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
`;
